/**
 * Whether a typed invitation code can be right, L1. The check is
 * `veri-plus-backend/src/utils/crockford.ts` `stripCheckSymbol`, carried: the
 * code is 26 Crockford symbols and one check symbol, the value mod 37, and the
 * API folds case, hyphens, spaces and O, I, L the same way. The API mails a
 * code before it looks the invitation up, so a typo caught here saves a person
 * two emails and a dead end.
 *
 * The 96 hex characters an older invitation carried are still accepted,
 * `normalizeTypedToken` in `src/utils/tokens.ts`.
 */
const ALPHABET = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';
const CHECK_ALPHABET = `${ALPHABET}*~$=U`;
const FOLD: Record<string, string> = { O: '0', I: '1', L: '1' };

export function invitationCodeLooksRight(raw: string): boolean {
  const trimmed = raw.trim();
  if (/^[0-9a-f]{96}$/i.test(trimmed)) return true;
  const cleaned = trimmed.toUpperCase().replace(/[\s-]/g, '');
  if (cleaned.length < 2) return false;
  let value = 0n;
  for (const char of cleaned.slice(0, -1)) {
    const digit = ALPHABET.indexOf(FOLD[char] ?? char);
    if (digit < 0) return false;
    value = value * 32n + BigInt(digit);
  }
  return CHECK_ALPHABET[Number(value % 37n)] === cleaned.slice(-1);
}
